import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActions,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import LockIcon from "@mui/icons-material/Lock";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Logo from "../Assets/Logo/logo2.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import noaccess from "../Assets/noaccess.gif";
import session_img from "../Assets/session.jpg";
import quiz_img from "../Assets/quiz.png";
import resource_img from "../Assets/resource.jpg";
import doubts_img from "../Assets/doubts.jpg";
import assignment_img from "../Assets/assignment.png";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { NavbarData } from "../components/NavbarData";
import QuizDialog from "../components/QuizDialog";
import {
  useSubjectContentQuery,
  useSubmitQuizMutation,
} from "../../app/services/userCore";
import { ToastContainer, toast } from "react-toastify";
import ResourceDialog from "../components/ResourceDialog";

export default function Hybrid() {
  const navigate = useNavigate();
  const { subject } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [subjectData, setSubjectData] = useState([]);
  const [currTopicCnt, setCurrTopicCnt] = useState(0);
  const [currTopicData, setCurrTopicData] = useState([]);
  const [currSectionData, setCurrSectionData] = useState([]);
  const [openQuizDialog, setOpenQuizDialog] = useState(false);
  const [openResourceDialog, setOpenResourceDialog] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const [resourceType, setResourceType] = useState(null);

  const areAllUnlockDatesSame = (data) => {
    if (data.length === 0) {
      return false;
    }
    return data.every((item) => item.unlockDate === "31-12-2099");
  };

  const {
    data: dataSubjectContent,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useSubjectContentQuery(subject);

  const [
    submitQuizCall,
    {
      data: dataSubmitQuiz,
      isLoading: isLoadingSubmitQuiz,
      isError: isErrorSubmitQuiz,
      isSuccess: isSuccessSubmitQuiz,
      error: errorSubmitQuiz,
    },
  ] = useSubmitQuizMutation();

  useEffect(() => {
    if (isSuccess) {
      setSubjectData(dataSubjectContent["content"]);
      setCurrTopicData(dataSubjectContent["content"][currTopicCnt]);
    } else if (isError) {
      toast.error(
        error?.data?.message || "Something went wrong. Contact Admin!",
        {
          toastId: "error",
          onClose: () => {
            navigate("/home");
          },
        }
      );
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if (subjectData && areAllUnlockDatesSame(subjectData)) {
      toast.error("The current subject is locked.", {
        toastId: `subjectLocked`,
        onClose: () => {
          navigate("/home");
        },
      });
    }
  }, [subjectData]);

  useEffect(() => {
    if (dataSubjectContent) {
      setCurrTopicData(dataSubjectContent["content"][currTopicCnt]);
    }
  }, [currTopicCnt]);

  const handleOpenQuizDialog = (resource) => {
    setDialogData(resource);
    setOpenQuizDialog(true);
  };

  const handleCloseQuizDialog = () => {
    setDialogData({});
    setOpenQuizDialog(false);
  };

  const handleQuizSubmit = (quizResponses) => {
    const payload = {
      topicId: currTopicData["tid"],
      sectionId: currSectionData["sid"],
      resourceTitle: dialogData["title"],
      quizResponses: quizResponses,
    };
    submitQuizCall({
      subject: subject.toUpperCase(),
      payload: payload,
    });
  };

  useEffect(() => {
    if (isSuccessSubmitQuiz) {
      toast.success(
        dataSubmitQuiz?.data?.message ||
          "Quiz submitted successfully. Reloading the page.",
        {
          toastId: "quizSubmitSuccess",
        }
      );
      setTimeout(() => {
        handleCloseQuizDialog();
        window.location.reload();
      }, 2000);
    } else if (isErrorSubmitQuiz) {
      toast.error(errorSubmitQuiz?.data?.message || "Unable to submit quiz.", {
        toastId: "quizSubmitError",
      });
    }
  }, [isSuccessSubmitQuiz, isErrorSubmitQuiz]);

  const handleOpenResourceDialog = (resource, rType) => {
    setDialogData(resource);
    setResourceType(rType);
    setOpenResourceDialog(true);
  };

  return (
    <Container maxWidth="xl" sx={{ padding: "1rem" }}>
      {openQuizDialog && (
        <QuizDialog
          open={openQuizDialog}
          setOpen={setOpenQuizDialog}
          handleQuizSubmit={handleQuizSubmit}
          resourceData={dialogData}
        />
      )}

      {openResourceDialog && (
        <ResourceDialog
          open={openResourceDialog}
          setOpen={setOpenResourceDialog}
          subject={subject}
          resourceType={resourceType}
          resourceData={dialogData}
        />
      )}

      <div className="container-fluid mb-3 p-0">
        <nav className="navbar navbar-expand-lg shadow-md">
          <div className="container-fluid">
            <div className="form-inline mr-auto">
              <div
                className="btn btn-primary"
                onClick={() => setIsOpen(!isOpen)}
              >
                <MenuIcon />
              </div>
            </div>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                textAlign: "center",
                textTransform: "uppercase",
                fontFamily: "'Rubik', sans-serif",
                marginRight: "auto",
                fontWeight: 500,
                "@media (max-width: 560px)": {
                  fontSize: "1.45rem",
                },
                "@media (max-width: 390px)": {
                  fontSize: "1.25rem",
                },
              }}
            >
              {subject}
            </Typography>
            <Link className="navbar-brand text-primary mr-0" to="/">
              <img
                className="brand-logo"
                src={Logo}
                alt="O(1) Coding Club"
                srcSet=""
              />
            </Link>
          </div>
        </nav>

        <div className={`sidebar ${isOpen === true ? "active" : ""}`}>
          <div className="sd-header">
            <Link to="/" className="navbar-brand text-primary mr-0">
              <img
                className="brand-logo"
                src={Logo}
                alt="O(1) Coding Club"
                srcSet=""
              />
            </Link>
            <div className="btn btn-primary" onClick={() => setIsOpen(!isOpen)}>
              <CloseIcon />
            </div>
          </div>
          <div className="sd-body">
            <div className="NavBarData">
              <ul className="NavBarList">
                {NavbarData.map((val, key) => {
                  return (
                    <li key={key} className="row">
                      <div
                        id="icon"
                        onClick={() => {
                          window.location.href = val.link;
                        }}
                      >
                        {val.icon} {val.title}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`sidebar-overlay ${isOpen === true ? "active" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>

      {isLoading || isError || isLoadingSubmitQuiz ? (
        <>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1000,
            }}
            open={true}
          >
            <CircularProgress color="secondary" />
          </Backdrop>
        </>
      ) : (
        <Grid
          container
          spacing={3}
          rowSpacing={3}
          alignItems={"stretch"}
          justifyContent={"stretch"}
        >
          <Grid item xs={12} md={12}>
            <div
              style={{
                width: "100%",
                background: "#775DD0",
                padding: "2rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "1.3rem",
                  flexWrap: "wrap",
                  justifyContent: "space-evenly",
                }}
              >
                {subjectData &&
                  subjectData.map((item, index) => {
                    return (
                      <>
                        {item["unlockDate"] !== "31-12-2099" && (
                          <Box
                            onClick={() => {
                              setCurrTopicCnt(index);
                            }}
                            key={index}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              transition: "0.51s",
                              "&:hover": {
                                transform: "scale(1.2)",
                              },
                            }}
                          >
                            <div
                              style={{
                                width:
                                  window.innerWidth <= 760
                                    ? "4.5rem"
                                    : "6.4rem",
                                position: "relative",
                                cursor: "pointer",
                              }}
                            >
                              {item["status"] === 0 && (
                                <>
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      position: "absolute",
                                      top: 0,
                                      background: "#0f0f0fba",
                                      borderRadius: "1rem",
                                    }}
                                  />
                                  <LockIcon
                                    sx={{
                                      position: "absolute",
                                      color: "#f4f4f4",
                                      bottom: "0rem",
                                      left: "1.3rem",
                                    }}
                                  />
                                </>
                              )}
                              <img
                                src="https://cdn.pixabay.com/photo/2016/11/18/23/38/child-1837375__340.png"
                                alt=""
                                srcSet=""
                                style={{ width: "100%" }}
                              />
                            </div>

                            <Typography
                              sx={{
                                textAlign: "center",
                                fontFamily: "cursive",
                                fontSize: "1.1rem",
                                fontWeight: "500",
                                color: "#d2d5be",
                              }}
                            >
                              {item.topic}
                            </Typography>
                            {item["status"] === 0 && (
                              <Typography
                                sx={{
                                  textAlign: "center",
                                  fontSize: "1rem",
                                  fontWeight: "400",
                                  color: "lightgrey",
                                }}
                              >
                                unlocks on <br />
                                {item.unlock_date}
                              </Typography>
                            )}
                          </Box>
                        )}
                      </>
                    );
                  })}
              </Box>
            </div>
          </Grid>

          <Grid item xs={12} md={12}>
            <Container
              maxWidth="xl"
              sx={{ background: "#0F143C", padding: "2rem" }}
            >
              <Typography
                sx={{
                  fontFamily: "'Bebas Neue', cursive",
                  textAlign: "center",
                  fontSize: "4rem",
                  color: "white",
                  margin: "0 0 2rem 0",
                  paddingBottom: "1rem",
                  borderBottom: "2px solid white",
                  "@media (max-width: 400px)": {
                    fontSize: "2rem",
                  },
                }}
              >
                {currTopicData.topic}
              </Typography>

              {currTopicData.status === 1 ? (
                currTopicData.sections.map((section, index) => {
                  return (
                    <Accordion
                      key={section.title}
                      sx={{
                        marginBottom: "1rem",
                      }}
                      onClick={() => setCurrSectionData(section)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            flex: 1,
                            alignItems: "center",
                            padding: "0 2rem",
                          }}
                        >
                          <div style={{ marginRight: "auto" }}>
                            <Typography sx={{}} variant={"h6"}>
                              {section.title}
                            </Typography>
                            <Typography
                              sx={{ fontSize: "1rem", fontWeight: "200" }}
                            >
                              {section.description}
                            </Typography>
                          </div>
                        </Box>
                      </AccordionSummary>

                      <AccordionDetails>
                        <Container maxWidth={"lg"} style={{ padding: "2%" }}>
                          <Grid
                            container
                            spacing={6}
                            justifyContent={"space-evenly"}
                          >
                            {section.resources.map(
                              (resource, index2) =>
                                (resource.type !== "FORM" ||
                                  (resource.type === "FORM" &&
                                    resource.link !== undefined)) && (
                                  <Grid item xs={12} md={3}>
                                    <Card sx={{ maxWidth: 345 }} key={index2}>
                                      <CardMedia
                                        component="img"
                                        height="200"
                                        image={
                                          resource.type === "SESSION"
                                            ? session_img
                                            : resource.type === "QUIZ"
                                            ? quiz_img
                                            : resource.type === "RESOURCE"
                                            ? resource_img
                                            : resource.type === "ASSIGNMENT"
                                            ? assignment_img
                                            : resource.type === "FORM"
                                            ? doubts_img
                                            : ""
                                        }
                                        sx={{
                                          objectFit: "contain",
                                        }}
                                        alt="Logo"
                                      />

                                      <CardContent
                                        style={{
                                          height:
                                            window.innerWidth <= 760
                                              ? ""
                                              : "100px",
                                        }}
                                      >
                                        <Typography
                                          gutterBottom
                                          variant="h5"
                                          component="div"
                                        >
                                          {resource.title}
                                        </Typography>
                                      </CardContent>

                                      <CardActions>
                                        {resource.s3Key ? (
                                          <Button
                                            color="primary"
                                            onClick={() =>
                                              handleOpenResourceDialog(
                                                resource,
                                                resource.type === "SESSION"
                                                  ? "VIDEO"
                                                  : "PDF"
                                              )
                                            }
                                          >
                                            Open
                                          </Button>
                                        ) : resource.type !== "QUIZ" ? (
                                          <a
                                            href={resource.link}
                                            target="_blank"
                                          >
                                            <Button color="primary">
                                              Open
                                            </Button>
                                          </a>
                                        ) : (
                                          <></>
                                        )}

                                        {resource.type === "QUIZ" && (
                                          <Button
                                            color="primary"
                                            onClick={() =>
                                              handleOpenQuizDialog(resource)
                                            }
                                          >
                                            Open
                                          </Button>
                                        )}
                                      </CardActions>
                                    </Card>
                                  </Grid>
                                )
                            )}
                          </Grid>
                        </Container>
                      </AccordionDetails>
                    </Accordion>
                  );
                })
              ) : (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={noaccess}
                    width={window.innerWidth <= 760 ? "100%" : "25%"}
                  />{" "}
                  <br />
                  <br />
                  <Typography
                    sx={{
                      fontSize: "1.5rem",
                      textTransform: "uppercase",
                      fontWeight: "400",
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    Current Section is Locked. <br />
                    It unlocks on <b>{currTopicData.unlock_date}</b>
                  </Typography>
                </div>
              )}
            </Container>
          </Grid>
        </Grid>
      )}

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        pauseOnHover
      />
    </Container>
  );
}
